import {combineReducers} from 'redux'
import chat from './reducers/chat'

const rootReducer = combineReducers({
    chat: chat
})

export default rootReducer